export const formatearFechaLarga = (fechaStr) => {
    if (!fechaStr) return 'N/A';
    const d = new Date(fechaStr);
    if (isNaN(d.getTime())) return fechaStr;
    return d.toLocaleDateString('es-MX', {
        day: 'numeric',
        month: 'long',
        year: 'numeric'
    });
};

export const formatearFechaCorta = (fechaStr) => {
    if (!fechaStr) return 'Sin registro';
    const d = new Date(fechaStr);
    if (isNaN(d.getTime())) return fechaStr;
    return d.toLocaleDateString('es-MX', {
        day: 'numeric',
        month: 'short',
        year: 'numeric'
    });
};

export const esTieneAmbas = (row) => {
    if (!row) return false;
    return row.bTieneAmbas === true ||
        row.bTieneAmbas === 1 ||
        String(row.bTieneAmbas) === '1' ||
        String(row.bTieneAmbas).toLowerCase() === 'true';
};

export const copiarAlPortapapeles = (texto, showSuccessToast, showErrorToast) => {
    if (!texto || texto === 'N/A') return;
    navigator.clipboard.writeText(texto)
        .then(() => {
            if (showSuccessToast) showSuccessToast('UUID copiado al portapapeles.');
        })
        .catch(() => {
            if (showErrorToast) showErrorToast('Error al copiar el UUID.');
        });
};

export const aplicarOrdenamiento = (listado, orden) => {
    if (!listado || listado.length === 0) return [];
    const copia = [...listado];
    if (orden === 'DIAS_ASC') {
        copia.sort((a, b) => (a.iDiasVencidos || 0) - (b.iDiasVencidos || 0));
    } else {
        copia.sort((a, b) => (b.iDiasVencidos || 0) - (a.iDiasVencidos || 0));
    }
    return copia;
};
